import { createMachine, InterpreterFrom } from 'xstate';
import { RevealedGribble } from '../state-machine';
import { assign } from '@xstate/immer';
import { HatcheningContext } from '../context';
import { useActor } from '@xstate/react';
import { useContext } from 'react';

export type ManyRevealContext = {
  // this state is guaranteed to have at least 2 elements in it
  // ideally we should be using a form of zipper here but this
  // will do for now
  gribbles: RevealedGribble[];
  // 0 indexed
  page: number;
};

type ManyRevealEvents = { type: 'next' } | { type: 'previous' } | { type: 'finish' };

export const MANY_REVEAL_MACHINE = 'ManyRevealMachine';

export const manyRevealMachine = createMachine(
  {
    tsTypes: {} as import('./many-reveal-machine.typegen').Typegen0,
    schema: { context: {} as ManyRevealContext, events: {} as ManyRevealEvents },
    id: MANY_REVEAL_MACHINE,
    initial: 'first',
    states: {
      first: {
        on: {
          next: {
            target: 'decidePage',
            actions: 'incrementPage',
          },
        },
      },
      middle: {
        on: {
          next: {
            target: 'decidePage',
            actions: 'incrementPage',
          },
          previous: {
            target: 'decidePage',
            actions: 'decrementPage',
          },
        },
      },
      decidePage: {
        always: [
          {
            target: 'last',
            cond: 'canExit',
          },
          {
            target: 'first',
            cond: 'isFirstPage',
          },
          {
            target: 'middle',
          },
        ],
      },
      last: {
        on: {
          previous: {
            target: 'decidePage',
            actions: 'decrementPage',
          },
          finish: {
            target: 'end',
          },
        },
      },
      // like the one reveal machine, we want the user to have an opportunity
      // to send the end event before finalizing the machine
      end: {
        type: 'final',
      },
    },
  },
  {
    actions: {
      incrementPage: assign((ctx) => ctx.page++),
      decrementPage: assign((ctx) => ctx.page--),
    },
    guards: {
      canExit: (ctx) => ctx.page + 1 === ctx.gribbles.length,
      isFirstPage: (ctx) => ctx.page === 0,
    },
  },
);

export function useManyReveal() {
  return useActor(
    useContext(HatcheningContext).children.get(MANY_REVEAL_MACHINE)! as InterpreterFrom<
      typeof manyRevealMachine
    >,
  );
}
